/** Cross-browser text copy; matches legacy execCommand + clipboard API pattern. */
export function copyText(str) {
  const text = str == null ? '' : String(str);
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } catch (_) {
    /* */
  }
  document.body.removeChild(ta);
  try {
    void navigator.clipboard?.writeText(text);
  } catch (_) {
    /* */
  }
}
